import { combineReducers } from "redux";
import Auth from "@pillvery/redux/auth/reducer";
import Users from "@pillvery/redux/users/reducer";
import CreateUser from "@pillvery/redux/users/createOrUpdateUser/reducer";
import Layout from "@pillvery/redux/layout/reducer";
import Categories from "@pillvery/redux/categories/reducer";
import SubCategories from "@pillvery/redux/subCategories/reducer";
import Brands from "@pillvery/redux/brands/reducer";
import Products from "@pillvery/redux/products/reducer";
import Banners from "@pillvery/redux/banners/reducer";
import PillverySelects from "@pillvery/redux/selects/reducer";
import Promotions from "@pillvery/redux/promotions/reducer";
import Coupons from "@pillvery/redux/coupons/reducer";
import Ratings from "@pillvery/redux/ratings/reducer";
import Orders from "@pillvery/redux/orders/reducer";
import Suppliers from "@pillvery/redux/suppliers/reducer";
import Payments from "@pillvery/redux/payments/reducer";
import Accounting from "@pillvery/redux/accounting/reducer";
import ProductGroups from "@pillvery/redux/productGroups/reducer";
import Reports from "@pillvery/redux/reports/reducer";
import Notifications from "@pillvery/redux/notifications/reducer";
import Settings from "@pillvery/redux/settings/reducer";
import Profile from "@pillvery/redux/profile/reducer";
import Dashboard from "@pillvery/redux/dashboard/reducer";
import CreateOrUpdateProductGroup from "@pillvery/redux/productGroups/createOrUpdateProductGroup/reducer";
import CreateOrUpdateCategory from "@pillvery/redux/categories/createOrUpdateCategory/reducer";
import CreateOrUpdateBrand from "@pillvery/redux/brands/createOrUpdateBrand/reducer";
import CreateOrUpdateProduct from "@pillvery/redux/products/createOrUpdateProduct/reducer";
import CreateOrUpdateBanner from "@pillvery/redux/banners/createOrUpdateBanner/reducer";
import CreateOrUpdateSelect from "@pillvery/redux/selects/createOrUpdateSelect/reducer";
import CreateOrUpdatePromotion from "@pillvery/redux/promotions/createOrUpdatePromotion/reducer";
import CreateOrUpdateCoupon from "@pillvery/redux/coupons/createOrUpdateCoupon/reducer";
import Gifts from "@pillvery/redux/gifts/reducer";
import CreateOrUpdateGift from "@pillvery/redux/gifts/createOrUpdateGift/reducer";
import Blogs from "@pillvery/redux/blogs/reducer";
import CreateOrUpdateBlog from "@pillvery/redux/blogs/createOrUpdateBlog/reducer";
import CreateOrUpdateClassification from "@pillvery/redux/classifications/createOrUpdateClassification/reducer";
import Classifications from "@pillvery/redux/classifications/reducer";
import InsuranceCompanies from "@pillvery/redux/insuranceCompanies/reducer";
import CreateOrUpdateInsuranceCompany from "@pillvery/redux/insuranceCompanies/createOrUpdateInsuranceCompany/reducer";

export default combineReducers({
  Auth,
  Users,
  CreateUser,
  Layout,
  Categories,
  SubCategories,
  Brands,
  Products,
  Banners,
  PillverySelects,
  Promotions,
  Coupons,
  Ratings,
  Orders,
  Suppliers,
  Payments,
  Accounting,
  ProductGroups,
  Reports,
  Notifications,
  Settings,
  Profile,
  Dashboard,
  CreateOrUpdateProductGroup,
  CreateOrUpdateCategory,
  CreateOrUpdateBrand,
  CreateOrUpdateProduct,
  CreateOrUpdateBanner,
  CreateOrUpdateSelect,
  CreateOrUpdatePromotion,
  CreateOrUpdateCoupon,
  Gifts,
  CreateOrUpdateGift,
  Blogs,
  CreateOrUpdateBlog,
  CreateOrUpdateClassification,
  Classifications,
  InsuranceCompanies,
  CreateOrUpdateInsuranceCompany,
});
